/* eslint-disable no-param-reassign */
import { createSlice, createAction } from '@reduxjs/toolkit';

import initialState from '../../../domain/app/entities/ingresar';

// ---------------- Saga's response ----------------
function fetchingresarSuccess(state, action) {
  const { respuestaServicio } = action.payload;
  state.response = respuestaServicio;
  state.errorFetchConfirmar = false;
}

function fetchingresarError(state, action) {
  const { respuestaServicio } = action.payload;
  state.response = respuestaServicio;
  state.errorFetchConfirmar = true;
}


const fetchingresar = createAction('fetchingresar');

// ------------- connection ------------- //

const ingresarReducer = createSlice({
  name: 'Ingresar',
  initialState,
  reducers: {
    fetchingresarSuccess,
    fetchingresarError,
  },
});

export const ingresarAction = {
  ...ingresarReducer.actions,
  fetchingresar,
};

export default ingresarReducer.reducer;